import { IFeatureItem } from '../../../../../types/offerData';

const FEATURES_MAX_COUNT = 10;

export const showFullInfo = (featuresList: IFeatureItem[]) => {
  return featuresList.length <= FEATURES_MAX_COUNT;
};
